/* eslint-disable i18next/no-literal-string */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend"

import en from "./translations/en/translation.json";
import fr from "./translations/fr/translation.json";

export const resources = {
  en: { translation: en },
  fr: { translation: fr },
} as const;

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
  resources,
  fallbackLng: "en",
  preload: ["en", "fr"],
  interpolation: {
    escapeValue: false,
  },
  debug: process.env.NODE_ENV === "development",
});

export default i18n;
